import { createGlobalStyle } from "styled-components";
import { colors } from "@sonder/ui/source/styled/theme";

export const GlobalStyle = createGlobalStyle`
  .DraftEditor-root {
    box-sizing: border-box;
    position: relative;

    div[contenteditable] {
      line-height: 1.3rem;
      min-height: 1.3rem;
      overflow-y: auto;
    }

    .public-DraftEditorPlaceholder-root {
      color: ${colors.grayA};
      position: absolute;
      pointer-events: none;
    }
  }
`;
